import { createFileRoute, redirect } from "@tanstack/react-router";
import { PROJECT } from "@/app/capabilities/permissions";
import { requireProjectPermission } from "@/lib/route-guards";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/settings/"
)({
  async beforeLoad(ctx) {
    await requireProjectPermission(ctx, PROJECT.securitySettings.read);
    throw redirect({
      to: "/orgs/$organizationId/projects/$projectId/settings/user-verification",
      params: ctx.params,
    });
  },
  loader: () => ({
    crumb: "Settings",
  }),
});
